// extracted by mini-css-extract-plugin
export default {"skillContainer":"_35zxWOR-","skill":"_2dlXS7IV","skillEmpty":"IovXXFCw","backgroundImage":"_1wEAJokU","noLogo":"_34Hp1GuX"};